import { StdLiveCardStyle } from "./styled/StdLiveCards";
import { Tooltip } from "@mui/material";
import { useState } from "react";

interface IStdLiveCards {
	SName: string | undefined;
	SEmail: string;
	status: "live" | "submitted" | "unsubmitted";
	isClickable?: boolean;
}

function StdLiveCards({ SName, SEmail, status, isClickable }: IStdLiveCards) {
	const [isOpen, setIsOpen] = useState(false);

	function getStatusIcon(): JSX.Element {
		switch (status) {
			case "live":
				return (
					<div className="cards-live">
						<span
							className="live-icon"
							style={{ float: "right" }}
						></span>
					</div>
				);

			case "submitted":
				return <div id="tick-mark"></div>;

			default:
				return <div className="close"></div>;
		}
	}

	function handleCardClick() {
		if (!isClickable) return;

		setIsOpen(true);
	}
	return (
		<StdLiveCardStyle
			className={`mt-3 mx-3 cursor-pointer`}
			onClick={handleCardClick}
		>
			<div className="stdCardInfo">
				{getStatusIcon()}
				{SName && (
					<Tooltip title={SName} placement="bottom-start">
						<div className="studentName whitespace-nowrap overflow-hidden text-ellipsis">
							{SName}
						</div>
					</Tooltip>
				)}
				<Tooltip title={SEmail} placement="bottom-start">
					<div className="studentEmail whitespace-nowrap overflow-hidden text-ellipsis">
						{SEmail}
					</div>
				</Tooltip>
			</div>
		</StdLiveCardStyle>
	);
}

StdLiveCards.defaultProps = {
	status: "live",
};

export default StdLiveCards;
